import { render } from "./clientContents.vue?vue&type=template&id=79cd08e0&scoped=true"
import script from "./clientContents.vue?vue&type=script&lang=js"
export * from "./clientContents.vue?vue&type=script&lang=js"

import "./clientContents.vue?vue&type=style&index=0&id=79cd08e0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cd08e0"]])

export default __exports__